import React from 'react';

import type { HotelBedType } from '@this/domain/hotel/hotel';

import { BedTypeNoticeStyle } from '../styles/bed-type-notice.styles';

interface BedTypeNoticeProps {
  bedTypes: HotelBedType[] | null | undefined;
}

/**
 * ベッドタイプ注意書きコンポーネント
 * 複数のベッドタイプがある場合に注意メッセージを表示
 */
export const BedTypeNotice: React.FC<BedTypeNoticeProps> = ({ bedTypes }) => {
  if (!bedTypes || bedTypes.length <= 1) {
    return null;
  }

  const bedTypesText = bedTypes.map(bedType => bedType.description).join('、または');

  return (
    <div style={BedTypeNoticeStyle}>
      ※本プランでは予約確定後でもベッドタイプは確約されません。
      {bedTypesText}になる可能性があります。
    </div>
  );
};
